/**
 * batchLoadInmobiliarias — Sprint 1 (F5A-001)
 *
 * Resuelve el patrón N+1 donde cada fila de una lista de afiliados/asociados
 * disparaba una query individual a `inmobiliaria`.
 *
 * Uso:
 *   const map = await batchLoadInmobiliarias(docIds);
 *   const nombre = map.get(id)?.nombre_inmobiliaria;
 */

import {
  collection,
  getDocs,
  query,
  where,
  documentId,
} from 'firebase/firestore';
import { db } from '../firebaseConfig';

/** Divide array en chunks de tamaño n. */
function chunk<T>(arr: T[], size: number): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}

/**
 * Carga en batch los documentos de `inmobiliaria` para los IDs dados.
 * Deduplica y respeta el límite de 10 valores por query `in`.
 */
export async function batchLoadInmobiliarias(
  ids: (string | undefined | null)[]
): Promise<Map<string, any>> {
  const unique = Array.from(new Set(ids.filter(Boolean))) as string[];
  const result = new Map<string, any>();

  if (unique.length === 0) return result;

  const chunks = chunk(unique, 10); // Firestore máx 10 valores en `in`
  const snapshots = await Promise.all(
    chunks.map((c) =>
      getDocs(query(collection(db, 'inmobiliaria'), where(documentId(), 'in', c)))
    )
  );

  snapshots.forEach((snap) => {
    snap.docs.forEach((d) => result.set(d.id, { id: d.id, ...d.data() }));
  });

  return result;
}

export default batchLoadInmobiliarias;
